<div class="header-user-container" fxLayout="row" fxLayoutAlign="start center">

  <div fxFlex="1 0 auto" class="left-spacer"></div>

  <div *ngIf="trialExpiredMessage" class="trial-message-wrapper hide-mobile" style="width: 300px;" fxFlex="0 0 auto">
    <div class="trial-message-header">
      <span>{{trialExpiredMessage}}</span>
    </div>
  </div>

  <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
    <button fxHide.lt-md matTooltip="'Add to'" mat-flat-button class="plus-button hide-mobile"
      [matMenuTriggerFor]="plusMenu">
      <mat-icon [svgIcon]="'heroicons:plus'"></mat-icon>
    </button>


    <button matTooltip="'Notifications'" mat-icon-button class="action-icon-button"
      [matMenuTriggerFor]="notificationMenu" #notificationTrigger="matMenuTrigger">
      <mat-icon [svgIcon]="'heroicons:bell'"></mat-icon>
      <span class="notification-badge" *ngIf="unreadCount > 0">{{unreadCount}}</span>
    </button>

    <!-- Calendar -->
    <button fxHide.lt-md matTooltip="'Marketplace'" (click)="explore()" mat-icon-button
      class="action-icon-button hide-mobile">
      <mat-icon [svgIcon]="'heroicons:shopping-cart'"></mat-icon>
    </button>

    <!-- What's New Trigger -->
    <button fxHide.lt-md matTooltip="'What's New'" mat-icon-button class="action-icon-button hide-mobile"
      (click)="toggleWhatsNew()">
      <mat-icon [svgIcon]="'heroicons:sparkles'"></mat-icon>
    </button>

    <button *ngIf="posEnabled == 1" fxHide.lt-md matTooltip="'Billing'" mat-icon-button
      class="action-icon-button hide-mobile" (click)="gotoPos()">
      <mat-icon [svgIcon]="'heroicons:building-storefront'"></mat-icon>
    </button>

    <!-- User Menu -->
    <div class="user-profile-container" [matMenuTriggerFor]="userMenu">
      <div class="avatar-wrapper">
        <mat-icon>account_circle</mat-icon>
        <div class="status-indicator" [ngClass]="user.status"></div>
      </div>
      <div class="user-details" fxHide.lt-md>
        <span class="user-name">{{user.name || 'Admin'}}</span>
        <span class="user-role">{{user.role || 'Admin'}}</span>
      </div>
      <mat-icon class="chevron-icon">expand_more</mat-icon>
    </div>
  </div>

</div>

<!-- Menus -->
<mat-menu #plusMenu="matMenu" class="plus-menu-panel">
  <div class="plus-menu-content">
    <div class="plus-section">
      <div class="plus-section-header">QUICK ADD</div>
      <div class="plus-grid">
        <div class="plus-grid-item" (click)="addContact()">
          <div class="icon-circle">
            <mat-icon [svgIcon]="'heroicons:user-add'"></mat-icon>
          </div>
          <div class="item-label">Add Contact</div>
        </div>
        <div class="plus-grid-item" (click)="addAccount()">
          <div class="icon-circle">
            <mat-icon [svgIcon]="'heroicons:office-building'"></mat-icon>
          </div>
          <div class="item-label">Add Account</div>
        </div>
        <div class="plus-grid-item" (click)="addDeals()">
          <div class="icon-circle">
            <mat-icon [svgIcon]="'heroicons:currency-dollar'"></mat-icon>
          </div>
          <div class="item-label">Add Deal</div>
        </div>
        <!-- <div class="plus-grid-item" (click)="explore()">
          <div class="icon-circle">
            <mat-icon [svgIcon]="'heroicons:shopping-cart'"></mat-icon>
          </div>
          <div class="item-label">Marketplace</div>
        </div> -->
      </div>
    </div>
  </div>
</mat-menu>

<mat-menu #notificationMenu="matMenu" class="notification-menu-panel">
  <div class="notification-content-wrapper" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="notification-header" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="header-title-group" fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="header-icon">notifications_active</mat-icon>
        <span class="header-title">Notifications</span>
      </div>
      <button mat-icon-button class="header-more-btn" (click)="gotogrid()">
        <mat-icon>open_in_new</mat-icon>
      </button>
    </div>

    <!-- Filter Chips -->
    <div class="filter-chips-container" fxLayout="row">
      <button class="filter-chip" [class.active]="selectedFilter === 'all'" (click)="setFilter('all')">All</button>
      <button class="filter-chip" [class.active]="selectedFilter === 'mentions'"
        (click)="setFilter('mentions')">Mentions</button>
      <button class="filter-chip" [class.active]="selectedFilter === 'Duplicate Lead'"
        (click)="setFilter('Duplicate Lead')">Duplicate Leads</button>
    </div>

    <!-- Notifications List -->
    <div class="notification-scroll-area" (scroll)="onScroll($event)">
      <ng-container *ngIf="notificationList && notificationList.length > 0; else emptyState">
        <div *ngFor="let notification of notificationList" class="notification-item"
          [class.unread]="notification.isRead === 0">
          <div class="item-inner">
            <div fxLayout="row" fxLayoutAlign="space-between start">
              <span (click)="navigation(notification)" class="item-category">{{notification.title ||
                'Notification'}}</span>
              <button mat-icon-button class="item-more-btn" [matMenuTriggerFor]="itemMenu"
                (click)="$event.stopPropagation()">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #itemMenu="matMenu">
                <button mat-menu-item (click)="toggleRead(notification)">
                  <mat-icon>{{notification.isRead === 0 ? 'mark_as_unread' : 'mark_chat_read'}}</mat-icon>
                  <span>Mark as {{notification.isRead === 0 ? 'read' : 'unread'}}</span>
                </button>
              </mat-menu>
            </div>
            <p (click)="navigation(notification)" class="item-message">{{notification.message}}</p>
            <div class="item-footer" fxLayout="row" fxLayoutAlign="space-between center">
              <span class="item-time">{{notification.createdOn | date:'short'}}</span>
            </div>
          </div>
        </div>

        <!-- Loading Indicator -->
        <div *ngIf="loading" class="flex justify-center p-4">
          <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
        </div>
      </ng-container>

      <ng-template #emptyState>
        <div class="empty-state" fxLayout="column" fxLayoutAlign="center center">
          <mat-icon class="empty-icon">notifications_none</mat-icon>
          <span>No notifications yet</span>
        </div>
      </ng-template>
    </div>
  </div>
</mat-menu>

<mat-menu #userMenu="matMenu" class="modern-menu">
  <!-- <div class="menu-header">ACCOUNT</div> -->
  <button mat-menu-item (click)="profile()">
    <mat-icon [svgIcon]="'heroicons:user-circle'"></mat-icon>
    <span>My Profile</span>
  </button>
  <button mat-menu-item (click)="billing()">
    <mat-icon [svgIcon]="'heroicons:credit-card'"></mat-icon>
    <span>Billing & Subscription</span>
  </button>
  <button mat-menu-item (click)="openTwoFactorAuth()">
    <mat-icon [svgIcon]="'heroicons:shield-check'"></mat-icon>
    <span>{{ twoFactorEnabled ? 'Two Factor Authentication' : 'Enable Authentication' }}</span>
  </button>

  <!-- <div class="menu-header">SUPPORT</div> -->
  <button mat-menu-item (click)="startTour()">
    <mat-icon [svgIcon]="'heroicons:flag'"></mat-icon>
    <span>Tour</span>
  </button>

  <button mat-menu-item (click)="helpDesk()">
    <mat-icon [svgIcon]="'heroicons:question-mark-circle'"></mat-icon>
    <span>Help Desk</span>
  </button>

  <button mat-menu-item (click)="appDownload()">
    <mat-icon [svgIcon]="'heroicons:download'"></mat-icon>
    <span>Download Mobile App</span>
  </button>

  <button mat-menu-item (click)="referAndEarn()">
    <mat-icon [svgIcon]="'heroicons:share'"></mat-icon>
    <span>Refer & Earn</span>
  </button>

  <mat-divider></mat-divider>
  <button mat-menu-item (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons:logout'"></mat-icon>
    <span>Sign out</span>
  </button>
</mat-menu>

<!-- What's New Side Panel -->
<div class="whats-new-backdrop" *ngIf="showWhatsNew" (click)="closeWhatsNew()"></div>
<div class="whats-new-side-panel" [class.open]="showWhatsNew">
  <!-- Standard Topbar -->
  <div class="whats-new-topbar" *ngIf="!isSearchingWhatsNew">
    <div class="topbar-title">What's new</div>
    <div class="topbar-actions">
      <button mat-icon-button class="topbar-search" (click)="toggleWhatsNewSearch()">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button class="close-btn" (click)="closeWhatsNew()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Search Topbar -->
  <div class="whats-new-search-bar" *ngIf="isSearchingWhatsNew">
    <button mat-icon-button class="back-btn" (click)="closeWhatsNewSearch()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="search-input-wrapper">
      <input type="text" placeholder="Search in this feed" (input)="onWhatsNewSearch($event)"
        [value]="whatsNewSearchQuery" #searchInput>
      <mat-icon class="search-icon">search</mat-icon>
    </div>
  </div>

  <div class="whats-new-content">
    <ng-container *ngIf="whatsNewData && whatsNewData.length > 0; else noData">
      <div *ngFor="let item of whatsNewData" class="whats-new-item-container">

        <div class="whats-new-body">

          <div class="whats-new-header" fxLayout="row" fxLayoutAlign="start center">
            <div class="badge-new" *ngIf="item.category">{{item.category}}</div>
            <div class="whats-new-date">{{item.createdAt | date:'dd MMMM yyyy'}}</div>
          </div>

          <h3 class="whats-new-title">{{item.title}}</h3>
          <p class="whats-new-text" [innerHTML]="item.fullDescription"></p>

          <div class="whats-new-image" *ngIf="item.image!=''">
            <img [src]="serverPath + item.image" alt="Feature Image"
              style="width: 100%; border-radius: 12px; margin: 16px 0;">
          </div>

          <a class="whats-new-link" *ngIf="item.externalLink" [href]="item.externalLink"
            target="_blank">{{item.shortDescription}} ›</a>


          <div class="whats-new-reactions" fxLayout="row" fxLayoutAlign="center center">
            <div class="reactions-pill">
              <button mat-icon-button class="reaction">😞</button>
              <button mat-icon-button class="reaction">😐</button>
              <button mat-icon-button class="reaction">😊</button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noData>
      <div class="empty-search-state" fxLayout="column" fxLayoutAlign="center center" *ngIf="isSearchingWhatsNew">
        <mat-icon>search_off</mat-icon>
        <p>No results found for "{{whatsNewSearchQuery}}"</p>
      </div>
      <div class="empty-state" fxLayout="column" fxLayoutAlign="center center" *ngIf="!isSearchingWhatsNew">
        <mat-icon>info_outline</mat-icon>
        <p>Stay tuned for updates!</p>
      </div>
    </ng-template>
  </div>
</div>